import '../../css/spinner.css';

export function Spinner() {
    return <div className="spinner-loader" style={{display: 'block', position: 'relative', margin: 'auto'}}></div>;
}